export var GenderType;
(function (GenderType) {
    GenderType["MALE"] = "MALE";
    GenderType["FEMALE"] = "FEMALE";
    GenderType["NON_BINARY"] = "NON_BINARY";
    GenderType["GENDERQUEER"] = "GENDERQUEER";
    GenderType["GENDERFLUID"] = "GENDERFLUID";
    GenderType["AGENDER"] = "AGENDER";
    GenderType["TWO_SPIRIT"] = "TWO_SPIRIT";
    GenderType["BIGENDER"] = "BIGENDER";
    GenderType["DEMIBOY"] = "DEMIBOY";
    GenderType["DEMIGIRL"] = "DEMIGIRL";
    GenderType["ANDROGYNOUS"] = "ANDROGYNOUS";
    GenderType["NEUTROIS"] = "NEUTROIS";
    GenderType["OTHER"] = "OTHER";
})(GenderType || (GenderType = {}));
export var ProfileStatusCode;
(function (ProfileStatusCode) {
    ProfileStatusCode["MARKED_FOR_DELETION"] = "MARKED_FOR_DELETION";
    ProfileStatusCode["LAPSED"] = "LAPSED";
    ProfileStatusCode["TERMINATED"] = "TERMINATED";
    ProfileStatusCode["ACTIVE"] = "ACTIVE";
    ProfileStatusCode["INACTIVE"] = "INACTIVE";
})(ProfileStatusCode || (ProfileStatusCode = {}));
export var getCurrentStay = function (profile) {
    return profile === null || profile === void 0 ? void 0 : profile.currentStay;
};
export var getCurrentStays = function (profiles) {
    if (profiles === void 0) { profiles = []; }
    return profiles.map(function (p) { return p.currentStay; }).filter(Boolean);
};
